import React, { useEffect, useState } from 'react'
import { Card, Menu, Typography, Empty, Skeleton } from 'antd'
import { api } from '../services/api'

// eslint-disable-next-line react/prop-types
export default function RelatedProducts ({ codigo }) {
  const [relatedProducts, setRelatedProducts] = useState([])
  const [loading, setLoading] = useState(false)

  const host = process.env.REACT_APP_API_URL || 'http://localhost:3001'

  const getRelatedProducts = async (codigo) => {
    try {
      setLoading(true)
      const { data } = await api.get(`/products/related/${codigo}`)
      setRelatedProducts(Array.isArray(data) ? data : [])
    } catch (error) {
      console.error('Erro ao buscar produtos relacionados', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (codigo) getRelatedProducts(codigo)
  }, [codigo])

  return (
    <div style={{ position: 'sticky', top: 100, maxWidth: 350, margin: '20 0', paddingBottom: 20 }}>
      <Card title="Sugestões" bodyStyle={{ padding: 0 }}>
        {loading
          ? (
            <Menu mode="inline" selectable={false}>
              {[1, 2, 3].map(i => (
                <Menu.Item key={i} style={{ width: 250, height: 200, padding: 12 }}>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 12,
                      alignItems: 'center'
                    }}
                  >
                    <Skeleton.Image
                      style={{ width: 120, height: 120 }}
                      active
                    />

                    <Skeleton
                      active
                      title={{ width: '80%' }}
                      paragraph={{ rows: 1, width: '60%' }}
                    />
                  </div>
                </Menu.Item>
              ))}
            </Menu>
          )
          : relatedProducts.length === 0
            ? (
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description="Nenhum produto relacionado"
                style={{ padding: 24 }}
              />
            )
            : (
              <Menu mode="inline" selectable={false}>
                {relatedProducts.map(product => {
                  const imageId = product.images?.[0]?.id

                  return (
                    <Menu.Item
                      key={product._id}
                      onClick={() => {
                        window.location.href = `/details?code=${product.codigo}`
                      }}
                      style={{
                        height: 'auto',
                        padding: 12
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          gap: 12,
                          alignItems: 'center'
                        }}
                      >
                        {/* IMAGEM */}
                        <div
                          style={{
                            width: '100%',
                            borderTopLeftRadius: 8,
                            borderTopRightRadius: 8,
                            overflow: 'hidden',
                            background: '#f0f0f0',
                            flexShrink: 0
                          }}
                        >
                          <img
                            src={imageId ? `${host}/products/image/${imageId}` : '/no-image.png'}
                            alt="Imóvel"
                            style={{
                              width: '100%',
                              height: 300,
                              objectFit: 'cover',
                              display: 'block'
                            }}
                          />
                        </div>

                        {/* TEXTO */}
                        <div style={{ flex: 1 }}>
                          <div
                            style={{
                              fontWeight: 500,
                              wordBreak: 'break-word'
                            }}
                          >
                            <Typography.Text
                              style={{
                                display: 'block',
                                whiteSpace: 'normal',
                                wordBreak: 'break-word',
                                overflowWrap: 'break-word',
                                textAlign: 'center'
                              }}
                            >
                              {product.descricao}
                            </Typography.Text>

                          </div>

                          <Typography.Text type="secondary">
                            {Number(product.valor).toLocaleString('pt-BR', {
                              style: 'currency',
                              currency: 'BRL'
                            })}
                          </Typography.Text>
                        </div>
                      </div>
                    </Menu.Item>
                  )
                })}
              </Menu>
            )}
      </Card>
    </div>
  )
}
